export default __webpack_public_path__ + "static/logo_horizontal_colour_lockup-d831e62a27ad713b35df09cfea5f8014.svg";